<div [editableInStoryblok]="_editable()">
	<vp-link-list
		[linkListItems]="listItems"
		[showBorderTop]="true"
		[showDivider]="showDivider"
		[showIcons]="showIcons"
		[useChevron]="useChevron"
	/>
</div>
